<ng-container *ngIf="isReady()" id="results-wrapper">
  <pre>{{ this.data | json }}</pre>
</ng-container>
<ng-container *ngIf="!isReady()">
  <span>Aucun résultat...</span>
</ng-container>
